import { createSystem, defaultBaseConfig, defineConfig, defaultConfig } from "@chakra-ui/react"

const config = defineConfig({
    globalCss: {
      html: {
        colorPalette: "cyan", // Change this to any color palette you prefer
      },
    },
  })
  
  export const system = createSystem(defaultConfig, config)